import { render, staticRenderFns } from "./RosConnectInstructions.vue?vue&type=template&id=2479afe0&"
import script from "./RosConnectInstructions.vue?vue&type=script&lang=js&"
export * from "./RosConnectInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2479afe0')) {
      api.createRecord('2479afe0', component.options)
    } else {
      api.reload('2479afe0', component.options)
    }
    module.hot.accept("./RosConnectInstructions.vue?vue&type=template&id=2479afe0&", function () {
      api.rerender('2479afe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/RosConnectInstructions.vue"
export default component.exports